// extracted by mini-css-extract-plugin
export default {"chatSectionContainer":"styles_chatSectionContainer__9aEki","emptyMesssageContainer":"styles_emptyMesssageContainer__12ejI","slide-in-bottom":"styles_slide-in-bottom__a2eF4"};